var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.Utilities = OCS.Classes.Utilities || {};
OCS.Functions = OCS.Functions || {};
// Requires OCS.Classes.Utilities.base
OCS.Functions.define_text_utilities = function () {
    return new Class({
        Implements: [new Class(OCS.Interfaces.Utilities.base), new Class(OCS.Interfaces.Utilities.text)]
    });
};
OCS.Classes.Utilities.text = OCS.Functions.define_text_utilities();

